<div class="product-detail-page">
  @if (isLoading()) {
    <div class="container">
      <div class="loading-container">
        <div class="loading-spinner"></div>
        <p>Carregando produto...</p>
      </div>
    </div>
  } @else if (product()) {
    <div class="container">
      <!-- Breadcrumb -->
      <nav class="breadcrumb" aria-label="Breadcrumb">
        <a routerLink="/">Início</a>
        <span class="breadcrumb-separator">›</span>
        <a routerLink="/produtos">Produtos</a>
        <span class="breadcrumb-separator">›</span>
        <a [routerLink]="['/categoria', product()!.categoria.slug]">
          {{ product()!.categoria.nome }}
        </a>
        <span class="breadcrumb-separator">›</span>
        <span class="breadcrumb-current">{{ product()!.nome }}</span>
      </nav>

      <!-- Main Content -->
      <div class="product-layout">
        <!-- Galeria de Imagens -->
        <div class="product-gallery">
          <!-- Imagem Principal -->
          <div class="gallery-main">
            <img 
              [src]="currentImage" 
              [alt]="product()!.nome"
              class="main-image"
              (click)="openImageModal(selectedImageIndex())"
            />
            
            <!-- Botões de Navegação -->
            @if (images.length > 1) {
              <button 
                class="carousel-btn carousel-prev"
                (click)="selectedImageIndex() > 0 && selectImage(selectedImageIndex() - 1); $event.stopPropagation()"
                [disabled]="selectedImageIndex() === 0"
              >
                ‹
              </button>
              
              <button 
                class="carousel-btn carousel-next"
                (click)="selectedImageIndex() < images.length - 1 && selectImage(selectedImageIndex() + 1); $event.stopPropagation()"
                [disabled]="selectedImageIndex() === images.length - 1"
              >
                ›
              </button>
            }
            
            <div class="zoom-indicator">
              <img src="assets/icons/search.svg" alt="Zoom" class="zoom-icon">
              <span class="zoom-text">Clique para ampliar</span>
            </div>
          </div>

          <!-- Thumbnails -->
          @if (images.length > 1) {
            <div class="gallery-thumbnails">
              @for (image of images; track $index) {
                <button
                  class="thumbnail"
                  [class.active]="selectedImageIndex() === $index"
                  (click)="selectImage($index)"
                >
                  <img [src]="image" [alt]="'Imagem ' + ($index + 1)" />
                </button>
              }
            </div>
          }
        </div>

        <!-- Informações e Compra -->
        <div class="product-info">
          <!-- Título e Código -->
          <div class="product-header">
            <h1 class="product-title">{{ product()!.nome }}</h1>
            <p class="product-code">Código: {{ product()!.codigo }}</p>
            @if (product()!.descricaoCurta) {
              <p class="product-description-short">{{ product()!.descricaoCurta }}</p>
            }
          </div>

          <!-- Box de Compra -->
          <div class="purchase-box card">
            <!-- Preço -->
            <div class="price-section">
              <div class="product-price">
                <span class="currency">R$</span>
                <span class="value">{{ formatPrice(product()!.preco).replace('R$', '').trim() }}</span>
              </div>

              <!-- Opções de Parcelamento -->
              <div class="payment-options">
                <button 
                  class="payment-option"
                  [class.active]="selectedPaymentOption() === null"
                  (click)="selectPaymentOption(null)"
                >
                  <span class="option-label">À vista</span>
                  <span class="option-value">{{ formatPrice(product()!.preco) }}</span>
                </button>

                <button 
                  class="payment-option"
                  [class.active]="selectedPaymentOption() === 3"
                  (click)="selectPaymentOption(3)"
                >
                  <span class="option-label">3x sem juros</span>
                  <span class="option-value">{{ calculateInstallment(product()!.preco, 3) | currency:'BRL' }}</span>
                </button>

                <button 
                  class="payment-option"
                  [class.active]="selectedPaymentOption() === 6"
                  (click)="selectPaymentOption(6)"
                >
                  <span class="option-label">6x sem juros</span>
                  <span class="option-value">{{ calculateInstallment(product()!.preco, 6) | currency:'BRL' }}</span>
                </button>

                <button 
                  class="payment-option"
                  [class.active]="selectedPaymentOption() === 12"
                  (click)="selectPaymentOption(12)"
                >
                  <span class="option-label">12x sem juros</span>
                  <span class="option-value">{{ calculateInstallment(product()!.preco, 12) | currency:'BRL' }}</span>
                </button>
              </div>
            </div>

            <!-- Status de Estoque -->
            <div class="stock-section">
              @if (isInStock) {
                <div class="stock-badge" [class.low-stock]="hasLowStock">
                  <span class="stock-icon">✓</span>
                  <span class="stock-text">{{ stockText }}</span>
                </div>
              } @else {
                <div class="stock-badge out-of-stock">
                  <span class="stock-icon">✕</span>
                  <span class="stock-text">{{ stockText }}</span>
                </div>
              }
            </div>

            <!-- Botões de Ação -->
            <div class="action-buttons">
              <button class="btn btn-orange btn-lg w-100" (click)="contactWhatsApp()">
                <img src="assets/icons/whatsapp.svg" alt="WhatsApp" class="btn-icon">
                Consultar Valores
              </button>
              <button class="btn btn-secondary btn-lg w-100" (click)="requestQuote()">
                <img src="assets/icons/whatsapp.svg" alt="WhatsApp" class="btn-icon">
                Solicitar Orçamento
              </button>
              <p class="contact-info">
                Entre em contato para consultar disponibilidade
              </p>
            </div>
          </div>

          <!-- Compatibilidade -->
          @if (product()!.veiculoCompativel.length > 0) {
            <div class="compatibility-section card">
              <h3 class="section-title">Compatibilidade</h3>
              <div class="compatibility-list">
                @for (vehicle of product()!.veiculoCompativel; track $index) {
                  <div class="compatibility-item">
                    <span class="vehicle-icon">🚗</span>
                    <span class="vehicle-info">
                      <strong>{{ vehicle.marca }} {{ vehicle.modelo }}</strong>
                      <span class="vehicle-years">{{ vehicle.anoInicio }} - {{ vehicle.anoFim }}</span>
                    </span>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Abas de Informações -->
      <div class="product-tabs">
        <div class="tabs-container card">
          <!-- Descrição -->
          <div class="tab-content">
            <h2 class="tab-title">Descrição do Produto</h2>
            @if (product()!.descricao) {
              <p class="product-description">{{ product()!.descricao }}</p>
            } @else {
              <p class="product-description">{{ product()!.descricaoCurta || 'Produto de alta qualidade para seu veículo.' }}</p>
            }
          </div>

          <!-- Características -->
          <div class="tab-content">
            <h2 class="tab-title">Características</h2>
            <table class="specs-table">
              <tbody>
                <tr>
                  <td class="spec-label">Código</td>
                  <td class="spec-value">{{ product()!.codigo }}</td>
                </tr>
                <tr>
                  <td class="spec-label">Categoria</td>
                  <td class="spec-value">{{ product()!.categoria.nome }}</td>
                </tr>
                <tr>
                  <td class="spec-label">Tipo</td>
                  <td class="spec-value">
                    {{ product()!.tipo === 'P' ? 'Produto' : product()!.tipo === 'S' ? 'Serviço' : 'Serviço Especial' }}
                  </td>
                </tr>
                <tr>
                  <td class="spec-label">Formato</td>
                  <td class="spec-value">
                    {{ product()!.formato === 'S' ? 'Simples' : product()!.formato === 'V' ? 'Com variações' : 'Com composição' }}
                  </td>
                </tr>
                @if (product()!.unidade) {
                  <tr>
                    <td class="spec-label">Unidade</td>
                    <td class="spec-value">{{ product()!.unidade }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Imagem -->
    @if (showImageModal()) {
      <div class="image-modal" (click)="closeImageModal()">
        <button class="modal-close" (click)="closeImageModal()">✕</button>
        
        <div class="modal-content" (click)="$event.stopPropagation()">
          @if (modalImageIndex() > 0) {
            <button class="modal-nav modal-prev" (click)="prevModalImage()">‹</button>
          }
          
          <img 
            [src]="images[modalImageIndex()]" 
            [alt]="product()!.nome"
            class="modal-image"
          />
          
          @if (modalImageIndex() < images.length - 1) {
            <button class="modal-nav modal-next" (click)="nextModalImage()">›</button>
          }
          
          <div class="modal-counter">
            {{ modalImageIndex() + 1 }} / {{ images.length }}
          </div>
        </div>
      </div>
    }
  }
</div>

